<template>
  <!-- This element is mounted as an OL Overlay; keep it in the DOM always. -->
  <div ref="el" class="feature-popup" :class="{ 'feature-popup--hidden': !popup.visible }">
    <button class="feature-popup__close" @click="$emit('close')" aria-label="Close">✕</button>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="feature-popup__body" v-html="popup.html" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { PopupState } from '@/composables/useFeaturePopup'

defineProps<{ popup: PopupState }>()
defineEmits<{ (e: 'close'): void }>()

const el = ref<HTMLElement | null>(null)
defineExpose({ el })
</script>

<style scoped>
.feature-popup {
  background: #1e1e2e;
  color: #cdd6f4;
  border: 1px solid #45475a;
  border-radius: 8px;
  padding: 12px 36px 12px 14px;
  min-width: 180px;
  max-width: 320px;
  font-size: 13px;
  line-height: 1.5;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  pointer-events: auto;
  /* Arrow pointing down */
  position: relative;
}
.feature-popup::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  border: 8px solid transparent;
  border-top-color: #45475a;
  border-bottom: none;
}
.feature-popup--hidden {
  display: none;
}
.feature-popup__close {
  position: absolute;
  top: 6px;
  right: 8px;
  background: none;
  border: none;
  color: #a6adc8;
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
  padding: 2px 4px;
  border-radius: 3px;
  transition: color 0.15s;
}
.feature-popup__close:hover { color: #f38ba8; }

/* Style the HTML that comes from the template */
.feature-popup__body :deep(table) {
  border-collapse: collapse;
  width: 100%;
  margin-top: 6px;
}
.feature-popup__body :deep(th) {
  text-align: left;
  color: #89b4fa;
  font-weight: 500;
  padding: 2px 8px 2px 0;
  white-space: nowrap;
}
.feature-popup__body :deep(td) {
  padding: 2px 0;
  color: #cdd6f4;
}
.feature-popup__body :deep(strong) { color: #cba6f7; }
</style>